// extracted by mini-css-extract-plugin
export var messageSideLeft = "_s7-1";
export var stateContainer = "_s7-0";